/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ExpenseCategory } from './';
import {
    ExpenseCategoryFromJSON,
    ExpenseCategoryFromJSONTyped,
    ExpenseCategoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExpenseProjectInfoResourceDeductibleCategoriesInner
 */
export interface ExpenseProjectInfoResourceDeductibleCategoriesInner {
    /**
     * 
     * @type {ExpenseCategory}
     * @memberof ExpenseProjectInfoResourceDeductibleCategoriesInner
     */
    category: ExpenseCategory;
    /**
     * 
     * @type {string}
     * @memberof ExpenseProjectInfoResourceDeductibleCategoriesInner
     */
    countryCode: string;
    /**
     * 
     * @type {number}
     * @memberof ExpenseProjectInfoResourceDeductibleCategoriesInner
     */
    deductibleRate?: number;
    /**
     * 
     * @type {number}
     * @memberof ExpenseProjectInfoResourceDeductibleCategoriesInner
     */
    distanceRate?: number;
    /**
     * If (true), deductibleRate > 0 else deductibleRate = 0
     * @type {boolean}
     * @memberof ExpenseProjectInfoResourceDeductibleCategoriesInner
     */
    isDeductible: boolean;
}

/**
 * Check if a given object implements the ExpenseProjectInfoResourceDeductibleCategoriesInner interface.
 */
export function instanceOfExpenseProjectInfoResourceDeductibleCategoriesInner(value: object): value is ExpenseProjectInfoResourceDeductibleCategoriesInner {
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('isDeductible' in value) || value['isDeductible'] === undefined) return false;
    return true;
}

export function ExpenseProjectInfoResourceDeductibleCategoriesInnerFromJSON(json: any): ExpenseProjectInfoResourceDeductibleCategoriesInner {
    return ExpenseProjectInfoResourceDeductibleCategoriesInnerFromJSONTyped(json, false);
}

export function ExpenseProjectInfoResourceDeductibleCategoriesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseProjectInfoResourceDeductibleCategoriesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'category': ExpenseCategoryFromJSON(json['category']),
        'countryCode': json['countryCode'],
        'deductibleRate': json['deductibleRate'] == null ? undefined : json['deductibleRate'],
        'distanceRate': json['distanceRate'] == null ? undefined : json['distanceRate'],
        'isDeductible': json['isDeductible'],
    };
}

export function ExpenseProjectInfoResourceDeductibleCategoriesInnerToJSON(value?: ExpenseProjectInfoResourceDeductibleCategoriesInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'category': ExpenseCategoryToJSON(value['category']),
        'countryCode': value['countryCode'],
        'deductibleRate': value['deductibleRate'],
        'distanceRate': value['distanceRate'],
        'isDeductible': value['isDeductible'],
    };
}

